// TODO, add Select2 with Ajax functionality.
class Select2Controller {
  constructor($element, $attrs, $translate) {
    'ngInject';

    this.$element = $element;
    this.$attrs = $attrs;
    this.$translate = $translate;
  }

  $onInit() {
    if (!this.isAjax()) {
      this.initializedSimple();
    }
  }

  $doCheck() {
    if (this.ngModel.$viewValue === null) {
      this.select.val('').trigger('change');
    }
  }

  initializedSimple() {
    if (this.isMultiple()) {
      this.initiliazeMultipleSelect();
    }
  }

  initiliazeMultipleSelect() {
    if (this.options) {
      this.select = this.$element.find('select');
      this.select.attr('multiple', 'multiple');
      
      this.appendOptions(this.select);

      $(this.select).select2({
        placeholder: this.$translate.instant(this.$attrs.placeholder)
      });

      //handle events
      this.select.on('change', () => {
        this.ngModel.$setViewValue(this.select.val());
      });
    }
  }

  appendOptions(select) {
    angular.forEach(this.options, (option, index) => {
      let optionHTML = '<option value=' + option.value + '>' + this.$translate.instant(option.text) + '</option>';
      select.append(optionHTML);
    });
  }

  // Ajaxable, I can't help it :)
  initializedAjaxable() {

  }

  // Returns true if the component has
  // ajax attribute.
  isAjax() {
    return this.$attrs.hasOwnProperty('ajax');
  }

  // Returns true if the component has
  // multiple attribute.
  isMultiple() {
    return this.$attrs.hasOwnProperty('multiple');
  }
}

export default Select2Controller;



// WEBPACK FOOTER //
// ./client/app/shared/ui/select2/select2.controller.js